export const normalizeArray = arr => {
    if (!Array.isArray(arr)) {
        throw new Error('Argument is not an Array');
    }

    const normalizedArray = {};
    arr.forEach(item => {
        normalizedArray[item.id] = item;
    });
    return normalizedArray;
};
